import React from "react";
import { useState } from "react";
import Carousel from "react-bootstrap/Carousel";

import "./CarouselStandCard.css";

const CarouselStandCard = (props) => {

    const [index, setIndex] = useState(0);
  
    const handleSelect = (selectedIndex, e) => {
      setIndex(selectedIndex);
    };

    const urls = props.description ? props.description.split(";") : [];

    const handleImageClick = (i) => {
    const url = urls[i]?.trim();
    if (url) {
      window.open(`${url}#sec1`, "_self"); 
    }
    };
    
    return (
        <div
            className={`carousel-stand-card carousel-stand-card--${
                props.preview ? "preview" : "grid"
            }`}
        >

    <Carousel activeIndex={index} onSelect={handleSelect} indicators={true} interval={null} className="product-image-carrusel" controls={false}>
        
        {props.imageArray.map((item, index) => (
          <Carousel.Item key={index} interval={4500}><img src={`${process.env.REACT_APP_API_URL}/${item}`} className="d-block w-100" alt={props.firstTitle} style={{ cursor: "pointer" }} onClick={() => handleImageClick(index)} />  
          </Carousel.Item>
        ))}
    </Carousel>
   
        
        </div>
    );
};

export default CarouselStandCard;
